<script setup>
import { computed, defineProps } from 'vue'
import { useRoute } from 'vue-router'

defineProps({
  firstGroupColors: Array,
  secondGroupColors: Array,
  firstGroup: String,
  secondGroup: String,
})

const route = useRoute()
const isPreviewMode = computed(() => route.query['view-mode'] === '1')
</script>

<template>
  <div
    :class="{ 'selected-brushes_preview': isPreviewMode }"
    class="selected-brushes"
  >
    <h2 class="brush-map__title">4. Выбранные ёршики</h2>
    <div class="selected-brushes__content">
      <h3 v-if="firstGroup !== 'none'" class="selected-brushes__title">
        {{ firstGroup }}
      </h3>
      <div class="selected-brushes__items">
        <div
          v-for="brush in firstGroupColors"
          class="selected-brushes__item"
          @click="$emit('deleteColor', brush.color)"
        >
          <div
            :style="{ background: brush.color }"
            class="selected-brushes__circle"
          ></div>
          <span>{{ brush.colorName }}</span>
          <svg
            v-if="!isPreviewMode"
            fill="none"
            height="9"
            viewBox="0 0 9 9"
            width="9"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="4.60914" cy="4.261" fill="#8D8D8D" r="3.84352" />
            <path
              d="M5.64497 5.41406L3.45561 3.10795M3.57236 5.41406L5.76172 3.10795"
              stroke="white"
              stroke-linecap="round"
              stroke-width="0.683292"
            />
          </svg>
        </div>
      </div>
      <div v-if="secondGroup !== 'none'" class="selected-brushes__bottom">
        <h3 class="selected-brushes__title">{{ secondGroup }}</h3>
        <div class="selected-brushes__items">
          <div
            v-for="brush in secondGroupColors"
            class="selected-brushes__item"
            @click="$emit('deleteColor', brush.color)"
          >
            <div
              :style="{ background: brush.color }"
              class="selected-brushes__circle"
            ></div>
            <span>{{ brush.colorName }}</span>
            <svg
              v-if="!isPreviewMode"
              fill="none"
              height="9"
              viewBox="0 0 9 9"
              width="9"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="4.60914" cy="4.261" fill="#8D8D8D" r="3.84352" />
              <path
                d="M5.64497 5.41406L3.45561 3.10795M3.57236 5.41406L5.76172 3.10795"
                stroke="white"
                stroke-linecap="round"
                stroke-width="0.683292"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/apps/styles/teeth';
@import '@/apps/styles/resources/index';

.selected-brushes {
  margin-top: 12px;
  border-radius: 6px;
  padding: 17px 21px;
  width: 100%;
  min-width: 350px;
  background: #f6f6f6;

  &_preview {
    margin-top: 45px;
  }

  &__title {
    margin-top: 12px;
    font-family: 'Manrope', sans-serif;
    font-weight: 700;
    font-size: $size--10;
    line-height: 11px;
    color: #808080;
  }

  &__circle {
    border-radius: 50%;
    width: 17px;
    height: 17px;
  }

  &__items {
    display: flex;
    flex-wrap: wrap;
    margin-top: 5px;
    gap: 10px;
  }

  &__item {
    @include flex;

    border: 1px solid #ededed;
    border-radius: 7px;
    padding: 4.27px 6px;
    font-family: 'SF Pro Display', sans-serif;
    font-weight: 400;
    font-size: $size--12;
    background: #fff;
    cursor: pointer;
    gap: 8px;

    &_preview {
      pointer-events: none;
    }
  }
}
</style>
